/** @module csi/datasheet/EditCanvasController */
define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/action/Controller",
	"csi/locale",
	"csi/widget/MessageDialog"
], function(declare,_,Controller,locale,MessageDialog) {

	return declare(Controller, {

		bShowWait: true,

		/**
		 * @override
		 * Confirm is necessary if there are any pages still containing SVG content rather than JSON content
		*/
		hasToConfirmAction: function() {
			var view = this.widget;
			var cache = view.cacheView;
			var urls = view.getVisibleNodes();

			var pages = cache.getNodes(urls);

			// Any pages with valid Content belong to mobile apps
			return _.some(pages, function(page) {
				return page.Content;
			});
		},

		/**
		 * @override
		 * Customize the confirm dialog
		 */
		confirmAction: function(params) {
			params = params || {};
			params.materialIcon = MessageDialog.ICON_WARNING;
			params.title = locale.resource("CanvasMobileToWebTitle");
			params.message = locale.resource("CanvasMobileToWebMessage");

			this.inherited(arguments);
		},

		/**
		 * @override
		 * Update the bFromMobile value
		 */
		onConfirm: function(key) {
			if (key == MessageDialog.BUTTON_PROCEED) {
				this.widget.bFromMobile = true;
			}

			this.inherited(arguments);
		},

		/**
		 * @override
		 * Call the customer actions after postProcess
		 */
		postProcessSuccess: function() {
			this.widget.editCanvas();
		}
	});
});